module.exports = "/images/ny-life2-18.jpg";